import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler,register } from "@wm/components-base";


const DEFAULT_CLS = 'app-lottie';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-lottie',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmLottie]',
  template: `<ng-content></ng-content>`,
  providers: [
    provideAsWidgetRef(LottieComponent)
  ],
  exportAs: 'wmLottie',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class LottieComponent extends StylableComponent {
  static initializeProps = register('wm-lottie');

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

}

